export const products = [
  {
    id: 1,
    title: "Gym & Fitness Companion",
    subtitle: "React Native & Supabase Mobile Exercise Platform",
    badge: "Personal Product",
    status: "Live Web App & Mobile",
    iconName: "Dumbbell",
    accentColor: "from-indigo-500 to-purple-600",
    description: "Comprehensive React Native (Expo) mobile application engineered for gym-goers and personal trainers. Powered by Supabase auth & real-time database, local storage caching, native camera/gallery avatar upload modals, and an integrated Admin Backoffice for workout catalog management.",
    highlights: [
      "Supabase Auth & PostgreSQL sync with LocalDatabaseService fallback",
      "Native camera & gallery integration for gym profile photo updates",
      "Admin management panel for cataloging workouts & exercise sets",
      "Muscle group filtering & body metrics tracking (age, weight, height)"
    ],
    metric: "100% Offline Caching",
    tags: ["React Native", "Expo", "Supabase", "TypeScript", "AsyncStorage", "Native Camera API"],
    projectUrl: "https://gym-guider.vercel.app/",
    githubUrl: "https://github.com/matin808"
  },
  {
    id: 2,
    title: "Sahib App",
    subtitle: "Cross-Platform Service Discovery & Booking Platform",
    badge: "Personal Product",
    status: "Mobile App",
    iconName: "Smartphone",
    accentColor: "from-purple-500 to-pink-600",
    description: "Full-featured mobile application built with React Native for seamless local service discovery, instant provider booking, user authentication, and real-time push notification updates.",
    highlights: [
      "Mobile phone OTP authentication & rapid user onboarding",
      "Real-time service booking pipeline with status notifications",
      "Firebase Cloud Messaging (FCM) integration for mobile push alerts",
      "High-contrast mobile design system with smooth micro-interactions"
    ],
    metric: "<200ms Realtime Sync",
    tags: ["React Native", "TypeScript", "Firebase", "FCM", "Redux", "Tailwind"],
    projectUrl: "https://github.com/matin808",
    githubUrl: "https://github.com/matin808"
  }
];
